import { IconButton, Tooltip, useTheme as useMuiTheme } from '@mui/material';
import { Brightness4, Brightness7 } from '@mui/icons-material';
import { useTheme } from '../contexts/ThemeContext';

function ThemeToggle() {
  const { darkMode, toggleDarkMode } = useTheme();
  const muiTheme = useMuiTheme();

  return (
    <Tooltip title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}>
      <IconButton 
        onClick={toggleDarkMode} 
        color="inherit"
        sx={{
          backgroundColor: muiTheme.palette.mode === 'dark' 
            ? 'rgba(255, 255, 255, 0.1)' 
            : 'rgba(0, 0, 0, 0.05)',
          '&:hover': {
            backgroundColor: muiTheme.palette.mode === 'dark' 
              ? 'rgba(255, 255, 255, 0.2)' 
              : 'rgba(0, 0, 0, 0.1)',
          },
          transition: 'all 0.3s ease',
        }}
      >
        {darkMode ? (
          <Brightness7 sx={{ color: '#fbbf24' }} />
        ) : (
          <Brightness4 sx={{ color: '#6366f1' }} />
        )}
      </IconButton>
    </Tooltip>
  );
}

export default ThemeToggle;
